import React, { useState } from "react";
import clsx from "clsx";

export type CourtType = "high" | "district" | "Toogle";

interface Props {
  value?: CourtType;
  onChange?: (val: CourtType) => void;
}

const CourtToggle: React.FC<Props> = ({ value = "Toogle", onChange }) => {
  const [active, setActive] = useState<CourtType>(value);

  const handleChange = (type: CourtType) => {
    setActive(type);
    onChange?.(type);
  };

  return (
    <div className="relative flex w-64 bg-gray-200 rounded-full p-1">
      {/* 🔥 Sliding Indicator */}
      <div
        className={clsx(
          "absolute top-1 bottom-1 w-1/2 justify-self-right bg-white rounded-full shadow-md transition-all duration-300 ease-in-out",
          active === "high" ? "left-1 " : "left-[50%]",
        )}
      />

      {/* High Court */}
      <button
        onClick={() => handleChange("high")}
        className={clsx(
          "relative z-10 w-1/2 py-2 text-sm font-medium transition-colors",
          active === "high" ? "text-blue-600" : "text-gray-600",
        )}
      >
        High Court
      </button>

      {/* District Court */}
      <button
        onClick={() => handleChange("district")}
        className={clsx(
          "relative z-10 w-1/2 py-2 text-sm font-medium transition-colors",
          active === "district" ? "text-blue-600" : "text-gray-600",
        )}
      >
        District Court
      </button>
    </div>
  );
};

export default CourtToggle;
